import React from "react";
import { Circles } from "react-loader-spinner";
import "./LoadingSpinner.css";

const LoadingSpinner = () => {
  return (
    <div className="spinner">
      <div className="spinner-card">
        <Circles
          height="72"
          width="72"
          color="#1f684d"
          ariaLabel="loading"
        />

        <p>Loading...</p>
      </div>
    </div>
  );
};

export default LoadingSpinner;